function SecondaryButton(props) {
  return (
    <button onClick={props.onClick} className="btn btn-block btn-light">{props.text}</button>
  );
}

export default SecondaryButton;
